module.exports = __webpack_public_path__ + "static/media/solar-system.67abe249.svg";